import { render, staticRenderFns } from "./EbkFunc.vue?vue&type=template&id=2d88a352&scoped=true&"
import script from "./EbkFunc.vue?vue&type=script&lang=js&"
export * from "./EbkFunc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88a352",
  null
  
)

export default component.exports